<template>
    <div class="modal">
        <div class="text">
            이벤트 참여자만 플레이 가능합니다.
        </div>
        <div class="confirm" @click="goToEventPage">
            응모하러 가기
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        goToEventPage() {
            if (NODE_ENV === 'production' && NODE_REL === 'release') {
                location.href = '/site/cstmrcnter/cstmrEventDetailView.do?bbsId=BBSID_9960&bbscttSn=9259'
            } else {
                location.href = '/site/cstmrcnter/cstmrEventDetailView.do?bbsId=BBSID_9960&bbscttSn=1794'
            }
        }
    }
}
</script>

<style scoped>
    @import url(./modal);

    .confirm {
        margin: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/runner/Modal5.vue